import React from 'react';
import PropTypes from 'prop-types';
import {
    Animated,
    TextInput,
    TouchableWithoutFeedback,
    View,
    StyleSheet, Platform, I18nManager,
} from 'react-native';

import BaseInput from './BaseInput';
import {moderateScale} from '../../tools/Scaling';

let container = null;
let RefName = null;

export default class Fumi extends BaseInput {
    static propTypes = {
        /*
         * This is the icon component you are importing from react-native-vector-icons.
         * import FontAwesomeIcon from 'react-native-vector-icons/FontAwesome';
         * iconClass={FontAwesomeIcon}
         */
        iconClass: PropTypes.func.isRequired,
        /*
         * Passed to react-native-vector-icons library as name prop
         */
        iconName: PropTypes.string.isRequired,
        /*
         * Passed to react-native-vector-icons library as color prop.
         * Also used as textInput color.
         */
        iconColor: PropTypes.string,
        /*
         * Passed to react-native-vector-icons library as size prop.
         */
        iconSize: PropTypes.number,

        passiveIconColor: PropTypes.string,
        height: PropTypes.number,
    };

    static defaultProps = {
        height: moderateScale(48),
        iconColor: '#00aeef',
        iconSize: moderateScale(20),
        iconWidth: moderateScale(40),
        inputPadding: moderateScale(16),
        passiveIconColor: '#a3a3a3',
        animationDuration: 300,
    };

    constructor(props, context) {
        super(props, context);

        container = this;
        RefName = [`input+${props.refName}`];

    }

    focus_custom() {
        this[RefName].focus();
    }

    render() {
        const {
            _ref,
            lengthWord,
            iconClass,
            iconColor,
            iconSize,
            passiveIconColor,
            iconName,
            label,
            style: containerStyle,
            inputStyle,
            height: inputHeight,
            inputPadding,
            iconWidth,
            labelStyle,
            placeholder,
            multiline,
            onSubmitEditing,
            returnKeyType,
            keyboardType,
            autoFocus,
            _scroll,
            refName,
            border,
            descLabel,

        } = this.props;
        const {focusedAnim, value} = this.state;
        const AnimatedIcon = Animated.createAnimatedComponent(iconClass);
        const ANIM_PATH = inputPadding + inputHeight;
        const NEGATIVE_ANIM_PATH = ANIM_PATH * -1;
        let ViewCustomize = Platform.OS === 'web' ? View : TouchableWithoutFeedback;


        const transformParent = Platform.OS === 'web' && I18nManager.getConstants().isRTL && [
            {rotateX: '-180deg'}, {rotateY: '180deg'},
        ];
        const transformChild = Platform.OS === 'web' && I18nManager.getConstants().isRTL && [
            {rotateX: '180deg'}, {rotateY: '180deg'},
        ];

        return (
            <Animated.View
                style={[styles.container, containerStyle,
                    border && Platform.OS !== 'web' ? {
                        borderColor: focusedAnim.interpolate({
                            inputRange: [0, 0.5, 1],
                            outputRange: [passiveIconColor, iconColor, iconColor],
                        }),
                    } : {}, {
                        height: ANIM_PATH,
                        // rotate: '180deg',
                        //  scaleY: -1,
                        //scaleX: -1,
                        //  rotateY: '-180deg'
                        transform: transformParent,
                    }]}
                onLayout={this._onLayout}
            >
                <TouchableWithoutFeedback
                    disabled={true}
                    style={{
                        alignItems: 'center', justifyContent: 'center',


                    }}
                    onPress={() => this.focus_custom()}
                >
                    <AnimatedIcon
                        name={iconName}
                        color={iconColor}
                        size={iconSize}
                        style={{
                            position: 'absolute',
                            left: moderateScale(8),
                            bottom: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 0.51, 0.7, 1],
                                outputRange: [
                                    24,
                                    ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    24,
                                ],
                            }),
                            color: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 1],
                                outputRange: [passiveIconColor, iconColor, iconColor],
                            }),
                            transform: transformChild,
                        }}
                    />
                </TouchableWithoutFeedback>
                <Animated.View
                    style={[
                        styles.separator,
                        {
                            height: inputHeight,
                            //left: iconWidth + moderateScale(1),
                            left: iconWidth - moderateScale(8),
                            backgroundColor: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 1],
                                outputRange: [passiveIconColor, iconColor, iconColor],
                            }),
                        },

                    ]}
                />
                <ViewCustomize
                    //disabled={true}

                    /* onPress={()=>{
                         alert("djkhjfkv")
                     }}*/
                    onPress={() => this.focus_custom()}
                >
                    <Animated.View
                        style={{
                            position: 'absolute',
                            // left: iconWidth + inputPadding,
                            left: iconWidth,
                            height: inputHeight,
                            top: focusedAnim.interpolate({
                                inputRange: [0, 0.5, 0.51, 0.7, 1],
                                outputRange: [
                                    moderateScale(14),
                                    ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    NEGATIVE_ANIM_PATH,
                                    inputPadding / 6,
                                ],
                            }),

                        }}
                    >
                        <Animated.Text
                            style={[
                                styles.label,
                                {
                                    fontSize: focusedAnim.interpolate({
                                        inputRange: [0, 0.7, 0.71, 1],
                                        outputRange: [16, 16, 12, 12],
                                    }),
                                    color: focusedAnim.interpolate({
                                        inputRange: [0, 0.7],
                                        outputRange: ['#939393', '#a3a3a3'],
                                    }),
                                },
                                labelStyle,
                                {
                                    transform: transformChild,
                                },
                            ]}
                        >
                            {descLabel ? descLabel : label}
                        </Animated.Text>
                    </Animated.View>
                </ViewCustomize>
                <TextInput
                    // ref={this.input}
                    //  ref={this[`input${refName}`]}
                    //  ref={this[`input${refName}`]}

                    //  ref={ref}
                    {...this.props}
                    ref={rf => this[RefName] = rf}
                    //ref={ref}

                    style={[
                        styles.textInput,
                        {
                            // marginLeft: iconWidth + inputPadding,
                            marginLeft: iconWidth,
                            color: iconColor,
                        },
                        inputStyle,
                        Platform.OS === 'web' && {outlineColor: iconColor},

                        {
                            transform: transformChild,
                        },
                    ]}
                    value={value}
                    onBlur={this._onBlur}
                    onFocus={this._onFocus}
                    onChange={this._onChange}
                    underlineColorAndroid={'transparent'}
                    multiline={multiline ? true : false}
                    keyboardType={keyboardType ? keyboardType : 'default'}
                    // placeholder={placeholder}
                    // onSubmitEditing={onSubmitEditing}
                    // onSubmitEditing={()=>this._onSubmitEditing(refName)}
                    //onSubmitEditing={()=>alert("")}
                    returnKeyType={returnKeyType ? returnKeyType : 'next'}
                    // autoFocus={autoFocus}
                    caretHidden={(Platform.OS === 'android' && Platform.Version < 23)}
                    //autoFocus

                    //  ref={ref}
                    //onFocus={onFocus}
                />
            </Animated.View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        overflow: 'hidden',
        paddingTop: moderateScale(4),
        backgroundColor: 'white',

    },
    label: {
        fontSize: moderateScale(12),
        fontWeight: 'bold',
        marginStart: moderateScale(4),
    },
    textInput: {
        flex: 1,
        marginBottom: moderateScale(2),
        marginEnd: moderateScale(2),
        color: 'black',
        fontSize: moderateScale(12),
        padding: moderateScale(2),
        paddingStart: moderateScale(4),
    },
    separator: {
        position: 'absolute',
        width: moderateScale(1),
        backgroundColor: '#f0f0f0',
        top: moderateScale(8),
    },
});
